import { RecordsType } from '@/types/performanceManager'
import { create } from 'zustand'

interface PMUnfinishedRecordsState {
    selectedType: RecordsType
}

interface PMUnfinishedRecordsActions {
    setSelectedType: (type: RecordsType) => void
}

export const usePMUnfinishedRecordsStore = create<PMUnfinishedRecordsState & PMUnfinishedRecordsActions>()((set) => ({
    selectedType: RecordsType.Unfinished,
    setSelectedType: (selectedType: RecordsType) => set({ selectedType }),
}))
